

export default function InboxTitle (){
    return (
      <h1 className="text-c32 text-black22 font-bold ">Inbox</h1>
    )
}